import { FormProvider } from 'react-hook-form';
import FormBuilderWithLayout from '@/components/company/FormBuilderWithLayout';
import { IReward } from '@/states/reward.state';

interface RewardFormProps {
  formControl: any;
  formRef: React.RefObject<HTMLFormElement>;
  fields: any[];
  formMode: 'add' | 'edit';
  handleSave: (data: IReward) => void;
  reset: any;
  setFormMode: (mode: 'add' | 'edit' | null) => void;
}

export const RewardForm = ({ formControl, formRef, fields, formMode, handleSave, reset, setFormMode }: RewardFormProps) => {
  const { handleSubmit } = formControl;

  return (
    <FormProvider {...formControl}>
      <form ref={formRef} onSubmit={handleSubmit(handleSave)} className="mt-4">
        <FormBuilderWithLayout
          description={formMode === 'add' ? 'Create Reward' : 'Edit Reward'}
          fields={fields}
          onSubmit={handleSubmit(handleSave)}
          onCancel={() => {
            reset({ name: '', value: '', description: '', org_chart_node_id: undefined });
            setFormMode(null);
          }}
          submitLabel={formMode === 'add' ? 'Save' : 'Update'}
          cancelLabel="Cancel"
          showPublishButton
        />
      </form>
    </FormProvider>
  );
};
